import { path, map } from "ramda";
import { createSelector } from "reselect";

export const organizationsSelector = path(["organizations", "data"]);
export const organizationsIsLoadingSelector = path([
  "organizations",
  "isLoading",
]);
export const matchedOrganizationsSelector = path([
  "organizations",
  "matchedOrganizations",
]);
export const organizationsOptionsSelector = createSelector(
  organizationsSelector,
  map((n) => ({
    value: n.id,
    label: n.description !== "" ? n.description : n.name,
  }))
);



// WEBPACK FOOTER //
// ./src/selectors/organizationSelectors.js